var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.5 27.5",
    style: {
      enableBackground: "new 0 0 24.5 27.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M12.8,19.8l7.6-5.3c0.2-0.1,0.3-0.3,0.3-0.6c0-0.2,0-0.5-0.2-0.6c-0.3-0.4-0.8-0.5-1.2-0.2l-6.3,4.2v-16 c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v16l-6.3-4.2C4.9,13,4.7,13,4.5,13c-0.2,0-0.4,0.2-0.6,0.3c-0.1,0.2-0.2,0.4-0.2,0.7 c0,0.2,0.2,0.4,0.3,0.6l7.8,5.3l0.1,0.1c0.2,0.1,0.4,0.1,0.6,0l0.1-0.1L12.8,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M23.2,19.8c-0.5,0-0.9,0.4-0.9,0.9v4.6H2.2v-4.6c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v5.5 c0,0.5,0.4,0.9,0.9,0.9h21.8c0.5,0,0.9-0.4,0.9-0.9v-5.5C24.1,20.2,23.7,19.8,23.2,19.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.65508551.svg";
export { ForwardRef as ReactComponent };